import React from "react";
import { Image, Pagination, Card, Reveal, Modal } from "semantic-ui-react";
import Jihyo from "../images/jihyo.jpg";
import Jihyo2 from "../images/jihyo2.jpg";
import Jihyo3 from "../images/jihyo3.jpg";
import Nayeon from "../images/nayeon.jpg";
import Nayeon2 from "../images/nayeon2.jpg";
import Nayeon3 from "../images/nayeon3.jpg";
import Jeongyeon from "../images/jeongyeon.jpg";
import Jeongyeon2 from "../images/jeongyeon2.jpg";
import Jeongyeon3 from "../images/jeongyeon3.jpg";
import Momo from "../images/momo.jpg";
import Momo2 from "../images/momo2.jpg";
import Momo3 from "../images/momo3.jpg";
import Sana from "../images/sana.jpg";
import Sana2 from "../images/sana2.jpg";
import Sana3 from "../images/sana3.jpg";
import Mina from "../images/mina.jpg";
import Mina2 from "../images/mina2.jpg";
import Mina3 from "../images/mina3.jpg";
import Dahyun from "../images/dahyun.jpg";
import Dahyun2 from "../images/dahyun2.jpg";
import Dahyun3 from "../images/dahyun3.jpg";
import Chaeyoung from "../images/chaeyoung.jpg";
import Chaeyoung2 from "../images/chaeyoung2.jpg";
import Chaeyoung3 from "../images/chaeyoung3.jpg";
import Tzuyu from "../images/tzuyu.jpg";
import Tzuyu2 from "../images/tzuyu2.jpg";
import Tzuyu3 from "../images/tzuyu3.jpg";

const Photos = () => {
  const [open, setOpen] = React.useState(false);

  return (
    <div className="photos">
      <h1 style={{ fontSize: 26, margin: "20px" }}>
        Taste of Love Teaser Photos (Taste Ver.)
      </h1>

      <Card.Group itemsPerRow={3}>
        <Card color="blue" image={Nayeon} />
        <Card color="blue" image={Jihyo} />
        <Card color="blue" image={Mina} />
        <Card color="blue" image={Jeongyeon} />
        <Card color="blue" image={Momo} />
        <Card color="blue" image={Sana} />
        <Card color="blue" image={Dahyun} />
        <Card color="blue" image={Chaeyoung} />
        <Card color="blue" image={Tzuyu} />
      </Card.Group>

      <h1 style={{ fontSize: 26, margin: "20px" }}>
        Taste of Love Teaser Photos (Fallen Ver.)
      </h1>
      <Card.Group itemsPerRow={2}>
        <Card color="blue" image={Nayeon2} />
        <Card color="blue" image={Jihyo2} />

        <Card color="blue" image={Jeongyeon2} />
        <Card color="blue" image={Momo2} />
        <Card color="blue" image={Sana2} />
        <Card color="blue" image={Mina2} />
        <Card color="blue" image={Dahyun2} />
        <Card color="blue" image={Chaeyoung2} />
        <Card color="blue" image={Tzuyu2} />
      </Card.Group>
      <br></br>
      <h1 style={{ fontSize: 26, margin: "20px" }}>
        Taste of Love Teaser Photos (In Love Ver.){" "}
      </h1>
      <Card.Group itemsPerRow={3}>
        <Card color="blue" image={Nayeon3} />
        <Card color="blue" image={Jihyo3} />
        <Card color="blue" image={Chaeyoung3} />
        <Card color="blue" image={Jeongyeon3} />
        <Card color="blue" image={Momo3} />
        <Card color="blue" image={Sana3} />
        <Card color="blue" image={Mina3} />
        <Card color="blue" image={Dahyun3} />
        <Card color="blue" image={Tzuyu3} />
      </Card.Group>
    </div>
  );
};

export default Photos;
